import React from 'react';
import PropTypes from 'prop-types';
import Slider from '../../../utils/Slider';

import './HostSlider.css';

export default function HostSlider({ propertyId, images, videos }) {
  if (!images) {
    return null;
  }

  // explicitly cast the images to the matching slider format
  const sliderImages = images.map((img) => ({ id: img.id, url: img.url }));
  const sliderVideos = videos
    ? videos.map((video) => ({
        id: video.id,
        streamUrl: video.stream_url,
        posterUrl: video.poster_url,
      }))
    : [];

  return (
    <div className="host-slider">
      <div className="host-slider__wrapper">
        <div className="host-slider__slider">
          <Slider
            sliderId={`hostslider-${propertyId}`}
            images={sliderImages}
            videos={sliderVideos}
            usePagination
            useKeyboard
          />
        </div>
      </div>
    </div>
  );
}

HostSlider.propTypes = {
  propertyId: PropTypes.number.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      url: PropTypes.string.isRequired,
      description: PropTypes.string,
    }),
  ),
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      stream_url: PropTypes.string.isRequired,
      poster_url: PropTypes.string,
    }),
  ),
};
